/**
 * The Juhised section: the shelf index, one guide, and the editor.
 *
 * Nested routes rather than dialogs, because a guide is a thing people send
 * each other: `/guides/wordpress-igakuine-hooldus` has to survive being pasted
 * into a task, a chat message or a ticket reply.
 *
 * The editor is guarded by the ROUTE as well as by the button that opens it.
 * Reading is `view:crm` and writing is `manage:crm.kb`, so somebody who reached
 * `/muuda` by typing it gets the article back rather than a form whose Save can
 * only ever answer 403.
 */
import { Navigate, Route, Routes } from "react-router-dom";
import { userCanPlatform, type StaffUser } from "../../../lib/auth";
import { GuidesIndexPage } from "./GuidesIndexPage";
import { GuideArticlePage } from "./GuideArticlePage";
import { GuideEditor } from "./GuideEditor";

export function GuidesSection({ user }: { user: StaffUser }) {
  const canEdit = userCanPlatform(user, "manage:crm.kb");

  return (
    <Routes>
      <Route index element={<GuidesIndexPage user={user} />} />
      <Route path="uus" element={canEdit ? <GuideEditor user={user} /> : <Navigate to="/guides" replace />} />
      <Route path=":slug" element={<GuideArticlePage user={user} />} />
      <Route
        path=":slug/muuda"
        element={canEdit ? <GuideEditor user={user} /> : <Navigate to="/guides" replace />}
      />
      <Route path="*" element={<Navigate to="/guides" replace />} />
    </Routes>
  );
}
